import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {NotificationSettingComponent} from '../account-setting/user-settings/notification-setting/notification-setting.component';
import {UserService} from '../../services/user.service';
import {ActivatedRoute} from '@angular/router';
import {NotificationSetting} from '../../../models/user';
import {TranslateService} from '@ngx-translate/core';
import {ModalService} from '../../services/modal/modal.service';
import {AchooPopupComponent} from '../../core/achoo-popup/achoo-popup.component';
import {ApiStatusEnum} from '../../app.constants';
import * as Sentry from '@sentry/browser';
import {
  EventTrackerService, Page, TargetType,
  UserActionType
} from '../../services/event-tracker/event-tracker.service';

@Component({
  selector: 'email-settings',
  templateUrl: './email-settings.component.html',
  styleUrls: ['./email-settings.component.scss']
})
export class EmailSettingsComponent implements OnInit, OnDestroy {
  @ViewChild('notificationSetting') notificationSetting: NotificationSettingComponent;
  @ViewChild('emailSettingError') errorPopup: AchooPopupComponent;
  emailSettings: NotificationSetting;
  errorMessage: string;
  private userId: number;
  private token: string;
  updateSettingStatus: ApiStatusEnum;

  constructor(private userService: UserService,
              private modalService: ModalService,
              private activatedRoute: ActivatedRoute,
              private translate: TranslateService,
              private eventTracker: EventTrackerService) { }

  ngOnInit() {
    const userId = this.activatedRoute.snapshot.queryParams['userId'];
    const token = this.activatedRoute.snapshot.queryParams['token'];
    if (!userId || !token) {
      this.errorMessage = this.translate.instant('email_setting.errors.invalid_request');
      this.modalService.openInCenter(this.errorPopup, null, 'email-setting-error', true);
      return;
    }
    this.userId = Number(userId);
    this.token = token;
    this.loadUserEmailSetting(userId, token);
    this.eventTracker.trackEmailSetting(this.userId);
  }

  ngOnDestroy() {
    this.modalService.close();
  }

  loadUserEmailSetting(userId, token) {
    this.userService.getUserNotificationSettingByToken(userId, token).subscribe((res) => {
      this.emailSettings = res;
    }, (error) => {
      this.errorMessage = this.translate.instant('email_setting.errors.api_get_error');
      Sentry.captureException(new Error('Error occurred on Email Settings page.'));
      this.modalService.openInCenter(this.errorPopup, null, 'email-setting-error', true);
    });
  }

  saveSettings() {
    this.updateSettingStatus = ApiStatusEnum.SENDING;
    this.userService.saveUserNotificationSettingByToken(this.userId, this.token, this.emailSettings).subscribe((res) => {
      this.updateSettingStatus = ApiStatusEnum.SUCCESS;
      this.eventTracker.trackUserAction(UserActionType.UPDATE, Page.EMAIL_SETTING, {
        type: TargetType.USER,
        id: this.userId
      });
    }, (err) => {
      this.updateSettingStatus = ApiStatusEnum.FAILED;
      Sentry.captureException(new Error('Error occurred on Email Settings page.'));
    });
  }

  get isUpdateSettingFail() {
    return this.updateSettingStatus && this.updateSettingStatus === ApiStatusEnum.FAILED;
  }

  get isUpdateSettingSuccess() {
    return this.updateSettingStatus && this.updateSettingStatus === ApiStatusEnum.SUCCESS;
  }

  get isUpdatingSetting() {
    return this.updateSettingStatus && this.updateSettingStatus === ApiStatusEnum.SENDING;
  }

}



// WEBPACK FOOTER //
// ./src/app/main/email-settings/email-settings.component.ts